import { atom } from 'jotai'

/**
 * Whether the application is currently in maintenance mode (backend unavailable, HTTP 503).
 *
 * Set to `true` by the central response interceptor (`RestQueryProvider`) as soon as a REST call
 * receives a 503, and reset to `false` automatically as soon as a check call (polling) succeeds
 * again. Plain atom, not persisted: each tab detects its own state.
 */
export const isMaintenanceModeAtom = atom<boolean>(false)
